import {Component, OnInit, Inject, ViewChild, AfterViewInit, OnDestroy, HostListener} from '@angular/core';

import {UserService} from 'src/app/core/services/user.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatInput} from '@angular/material';
import {Subscription} from 'rxjs/internal/Subscription';
import {NgForm} from '@angular/forms';
import {NotificationService} from 'src/app/core/services/notification.service';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {CommonService} from 'src/app/core/services/common.service';
import {Message} from 'src/app/core/class/message';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-autho-user',
  templateUrl: './autho-user.component.html',
  styleUrls: ['./autho-user.component.scss']
})
export class AuthoUserComponent implements OnInit, AfterViewInit, OnDestroy {
  user = {
    id: null,
    tenantId: localStorage.getItem('tenantId'),
    userName: '',
    fullName: '',
    userType: null,
    enterpriseId: localStorage.getItem('enterpriseId'),
    phone: '',
    email: '',
    description: '',
    permissions: []
  };
  selectedIndex = -1;
  returnSelectedIndex = -1;
  dataList = new Array();
  selectedList = new Array();

  leftList = new Array();
  rightList = new Array();

  // Variable for saving original data list
  originalDataList = [];
  // Variable for saving original selected list
  originalSelectedList = [];
  // Variable for binding search feature words
  filterWords = '';
  filterWordsSelected = '';

  // Refer to form in view
  @ViewChild('f', {static: false}) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  checkEscKey = false;
  @ViewChild('focusInput', {static: false}) focusInput: MatInput;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (!this.checkEscKey) {
      this.onNoClick();
    }
  }

  constructor(
    private usService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AuthoUserComponent>,
    public notificationService: NotificationService,
    public dialog: MatDialog,
    public commonService: CommonService,
    private message: Message,
    private toastr: ToastrService
  ) {
    this.user.id = data.userId;
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onNoClick();
    });
  }

  ngOnInit() {
    this.getUserById(this.user.id);
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.focused = true);
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
  }

  onFilterFeatures() {
    const filterWords = this.filterWords.trim().toLowerCase();
    // Get new dataList according to filterWords
    this.dataList = this.originalDataList.filter((dataPermission) => {
      return this.commonService.checkFilterWords(dataPermission.name.toLowerCase(), filterWords);
    });
    // Remove items which are exist in this.selectedList
    this.dataList = this.dataList.filter(dataListPermission => {
      let found = false;
      for (const i of this.selectedList) {
        if (i.id == dataListPermission.id) {
          found = true;
          break;
        }
      }

      return !found;
    });
  }

  onFilterFeaturesSelected() {
    const filterWordsSelected = this.filterWordsSelected.toLowerCase().trim();
    // Get new dataList according to selectedList
    this.selectedList = this.originalDataList.filter((dataPermission) => {
      return this.commonService.checkFilterWords(dataPermission.name.toLowerCase(), filterWordsSelected);
    });
    // Remove items which are exist in this.dataList
    this.selectedList = this.selectedList.filter(dataListPermission => {
      let found = false;
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].id == dataListPermission.id) {
          found = true;
          break;
        }
      }
      return !found;
    });
  }

  moveClick() {
    for (let item of this.leftList) {
      this.dataList.splice(this.dataList.indexOf(item), 1);
      this.selectedList.push(item);
    }
    this.leftList = [];
  }

  returnClick() {
    for (let item of this.rightList) {
      this.selectedList.splice(this.selectedList.indexOf(item), 1);
      this.dataList.push(item);
    }
    this.rightList = [];
  }

  getIndex(i) {
    //this.selectedIndex = i;
    let idx = this.leftList.indexOf(i);
    if (idx >= 0) {
      this.leftList.splice(idx, 1);
    } else {
      this.leftList.push(i);
    }
  }

  getReturnIndex(i) {
    let idx = this.rightList.indexOf(i);
    if (idx >= 0) {
      this.rightList.splice(idx, 1);
    } else {
      this.rightList.push(i);
    }
  }

  moveAllClick() {
    this.isFormChanging = true;
    if (!this.selectedList) {
      this.selectedList = this.dataList.slice();
    } else {
      let i;
      for (i = 0; i < this.dataList.length; i++) {
        this.selectedList.push(this.dataList[i]);
      }
    }
    this.dataList.splice(0);
    this.leftList = [];
  }

  returnAllClick() {
    this.isFormChanging = true;
    if (!this.dataList) {
      this.dataList = this.selectedList.slice();
    } else {
      let i;
      for (i = 0; i < this.selectedList.length; i++) {
        this.dataList.push(this.selectedList[i]);
      }
    }
    this.selectedList.splice(0);
    this.rightList = [];
  }

  onclickButtonUpdate(userName: string) {
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      // them ten nguoi dung
      data: this.commonService.format(this.message.getMessage('messages.confirm_update_user'), userName)
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        const permissions = new Array();
        for (const permission of this.selectedList) {
          if (permission == null) {
            continue;
          }
          permissions.push(permission.id);
        }
        this.usService.updateUserPerEnterprise(
          this.user.id,
          {
            permissions,
          }
        ).subscribe(res => {
          if (res && res.success) {
            this.toastr.success(this.message.getMessage('messages.update_success'));
            this.dialogRef.close();
          } else {
            this.toastr.error(res.message);
          }
        })
      }
      dialogRe.close();
    });
  }

  /**
   * Get user by id
   * @param userId: any
   */
  getUserById(userId: any) {
    this.usService.getUser(userId)
      .subscribe(rs => {
        if (rs == null || rs.data == null) {
          return 0;
        }
        this.user = {
          ...this.user,
          ...rs.data
        };
        this.usService.getFeatureList(this.user.enterpriseId).subscribe(res => {
          if (res == null || res.data == null) {
            return 0;
          }
          this.dataList = res.data;
          this.originalDataList = this.dataList;
          if (this.user.permissions != null) {
            this.dataList = this.dataList.filter(dataListPermission => {
              const index = this.user.permissions.indexOf(dataListPermission.id);
              if (index !== -1) {
                this.user.permissions[index] = dataListPermission;
              }
              return index === -1;
            });
            this.selectedList = [...this.user.permissions];
          }
        }, error => {
          console.log(error);
        });
      });
  }

  /**
   * Close granting permission dialog
   */
  onNoClick() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }

  isChangePermission() {
    if ((this.user.permissions == null || this.user.permissions.length == 0) && (this.selectedList == null || this.selectedList.length == 0)) {
      return false;
    }

    if (this.user.permissions.length != this.selectedList.length) {
      return true;
    }

    for (const permission of this.selectedList) {
      if (permission == null) {
        continue;
      }
      if (this.user.permissions.indexOf(permission) < 0) {
        return true;
      }
    }
    return false;
  }
}
